function registerEvent(label, action, interactive = false) {
  const { gtag, dataLayer /* , _paq, pa */ } = window

  if (typeof gtag === 'function') {
    // GA - Google Analytics 4
    gtag('event', `${label}_${action}`, {
      category: 'flowbox',
      interactive,
    })
  } else if (dataLayer && typeof dataLayer.push === 'function') {
    // GTM - Google Tag Manager (modern)
    dataLayer.push({
      event: `${label}_${action}`,
      category: 'flowbox',
      interactive,
    })
  }

  // Matomo
  /* if (_paq && typeof _paq.push === 'function') {
    _paq.push(['trackEvent', 'flowbox', action, label])
  } */

  // Piano
  /* if (pa && typeof pa.sendEvent === 'function') {
    pa.sendEvent(`${label}_${action}`, {
      category: 'flowbox',
      interactive,
    })
  } */
}

export default registerEvent
